import { Avatar, Button, Stack, Typography } from '@mui/material';
import { CannabisContext } from 'Context/CannabisContext';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { OcrLoadingAnimation } from 'Images';
import { useContext } from 'react';

export const OcrLoading = () => {
  const { newInvoice, watchFile } = useContext(CannabisContext);

  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.Reimbursements
  ).ocrLading;
  const isDesktop = useIsDesktop();

  return (
    <Stack sx={{ mt: '100px', alignItems: 'center' }}>
      <Typography component={'h1'} variant='h3'>
        {dictionary.title}
      </Typography>
      <Typography
        textAlign={isDesktop ? undefined : 'center'}
        alignSelf={isDesktop ? undefined : 'center'}
        maxWidth={isDesktop ? undefined : '27ch'}
        component={'h2'}
        variant={'h6'}
        sx={isDesktop ? undefined : { fontWeight: 400, lineHeight: '24px' }}
        mt='40px'
      >
        {dictionary.subtitle}
      </Typography>
      <Avatar
        sx={{ mt: '16px', width: '170px', height: '132.6px' }}
        alt=''
        src={OcrLoadingAnimation}
      />
      {newInvoice.file && (
        <Stack
          sx={{
            bgcolor: '#F6F8FE',
            p: '32px',
            width: '100%',
            maxWidth: '800px',
            gap: '16px',
          }}
        >
          <Typography variant='body2'>{dictionary.inputLabel}</Typography>
          <Button
            variant='outlined'
            sx={{
              p: '11px 20px',
              width: '100%',
              borderRadius: '8px',
              bgcolor: 'white',
              justifyContent: 'flex-start',
              color: 'black',
            }}
            onClick={() => watchFile(newInvoice.file)}
          >
            <Typography variant='body1'>{newInvoice.file?.name}</Typography>
          </Button>
        </Stack>
      )}
    </Stack>
  );
};
